<template>
  <main class="full-height">
    <v-content class="full-height">
      <v-layout row wrap class="layout-search">
        <v-flex xs12>
          <form-alert
            :type="alertText.type"
            :message="alertText.message"
            @close="closeFormAlert"
          ></form-alert>
        </v-flex>
        <v-flex md10 sm12 xs12>
          <v-text-field
            @input="debounceInput(searchFilter.generalSearch)"
            class="general-search mt-0 pt-0"
            height="6vh"
            solo
            label="Pesquise pela razão social, nome, CNPJ, CPF, número da proposta/apólice ou modalidade"
            v-model="searchFilter.generalSearch"
            append-icon=" search"
            @click:append="advancedSearch(searchFilter.generalSearch)"
            v-on:keyup.enter="advancedSearch(searchFilter.generalSearch)"  
          ></v-text-field>
          
          <p v-if="visible" class="busca_status">Resultados da busca por {{this.filtroStatus}}:</p>
        
        </v-flex>
        <v-flex md2 sm12 xs12 pl-1 class="criar-menu-container" id="mesa_criar_demanda">
          <drop-down
            :items="yellowDropdownOptions"
            @menu-click="handleDropdownClickAction"
            >
            <template v-slot:title>
              <span>Criar</span>
              <v-icon class="ml-2">add_circle_outline</v-icon>
            </template>
          </drop-down>
        </v-flex>
      </v-layout>
      <v-container
        fluid
        class="kanban-container"
        v-if="cotacoes || cotacoesApolice"
      >
        <v-layout>
          <v-flex
            class="kanban-header"
            grow
            md3
            sm12
            v-for="(header, index) in headers"
            :key="index"
          >
            <v-layout class="kanban-header-title" :class="header.css">
              <v-flex class="xs11 compact-text">{{ header.descricao }}</v-flex>
              <v-flex class="xs1">
                {{
                  filteredProposals.filter((item) =>
                    header.fase.includes(item.fase)
                  ).length
                }}
              </v-flex>
            </v-layout>
            <v-layout class="kanban-column">
              <cotacoes-column
                :cotacoes="
                  filteredProposals.filter((item) =>
                    header.fase.includes(item.fase)
                  )
                "
                :title="header.titulo"
                :remove-border-left="true"
                :remove-border-right="true"
                @card-clicked="goToFullProposal"
              ></cotacoes-column>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-dialog
      v-model="selectEndorsementKindModal"
      width="500"
      content-class="select-endorsement-kind-modal"
    >
      <mesa-selecionar-tipo-apolice-modal
        @select="selectKindEndorsement"
        @close="resetEndorsementFlow"
      />
    </v-dialog>
      <v-dialog
    v-model="searchPolicyModal"
    content-class="search-policy-modal"
  >
    <pesquisar-apolice
      v-if="searchPolicyModal"
      :items="filteredPolicies"
      :kind-endorsement="selectedKindEndorsement"
      @search="filterPolicies"
      @selected-policy="handleSelectedPolicy"
      @close="searchPolicyModal = false"
    />
  </v-dialog>

    <v-dialog
      v-model="endorsementPermissionProblemsModal"
      width="700"
      content-class="endorsementPermissionProblems"
    >
      <problemas-permissao-endosso-modal
        v-if="endorsementPermissionProblemsModal"
        :validacoes="selectedPolicyForEndorsement.validacoes"
        @close="resetEndorsementFlow"
      />
    </v-dialog>
    <v-dialog
      v-model="showEndossoCancelamentoDialog"
      persistent
      :max-width="'1000'"
    >
      <base-modal>
        <endosso-cancelamento-component
          v-if="showEndossoCancelamentoDialog"
          :proposta="selectedPolicy"
          @fechar="showEndossoCancelamentoDialog = false"
        />
      </base-modal>
    </v-dialog>
  </main>
</template>

<script type="js">
import { KIND_ENDORSEMENTS, canEndorse } from '@/libs/endorsement';
import _ from "lodash";
import { isCNPJ, isCPF } from "@/libs/utils";
import ViewMixin from "@/mixins/ViewMixin";
import DropDown from "@/components/DropDown.vue";
import PesquisarApolice from "@/components/PesquisarApolice.vue";
import MesaSelecionarTipoApoliceModal from "@/components/MesaSelecionarTipoApoliceModal.vue";
import ProblemasPermissaoEndossoModal from "@/components/ProblemasPermissaoEndossoModal.vue";
import BuscaAvancadaApolice from "@/components/BuscaAvancadaApolice.vue";

export default {
  name: "MesaDeTrabalho",
  components: { 
    DropDown, 
    PesquisarApolice, 
    MesaSelecionarTipoApoliceModal,
    ProblemasPermissaoEndossoModal,
    BuscaAvancadaApolice
  },
  mixins: [ViewMixin],
  data: () => {
    
    return {
      KIND_ENDORSEMENTS,
      id_apolice: "",
      searchFilter: {
        generalSearch: "",
      },
      teste: null,
      model: {
      nome: null,
      apolice: null,
      cpf: null,
      cnpj: null,
      date: null,
      me: undefined,
    },
      selectedPolicy: false,
      filtroStatus: '',
      filteredCotacoes: null,
      filteredPolicies: [],
      searchPolicyModal: false,
      menu: null,
      visible: false,
      cotacoes: false,
      cotacoesApolice: false,
      generalSearch: "",
      selectEndorsementKindModal: false,
      endorsementPermissionProblemsModal: false,
      selectedPolicyForEndorsement: false,
      selectedKindEndorsement: false,
      showEndossoCancelamentoDialog: false,
      selectFilter: [{ text: "Seguro Garantia" },
      { text: "Fiança Locatícia" }],
      headers: [
        {
          descricao: "Aguardando Seguradora",
          fase: ["ANALISE"],
          titulo: "Vigentes",
          css: "text-blue",
          cssCard: "",
        },
        {
          descricao: "Aguardando Corretor",
          fase: ["ACAO_CORRETOR"],
          titulo: "Ação Corretor",
          css: "text-yellow",
          cssCard: "",
        },
        {
          descricao: "Apólices Emitidas",
          fase: ["EMITIDA"],
          titulo: "A Enviar",
          css: "text-green",
          cssCard: "",
        },
        {
          descricao: "Recusadas ou Descartadas",
          fase: ["CANCELADA", "RECUSADA"],
          titulo: "Recusadas",
          css: "text-gray",
          cssCard: "",
        },
      ],
      policiesPlusNomination: [],
      
      // o nome anterior, createDropdownOptions, causa confusão lol
      yellowDropdownOptions: {
        apolice: {
          name: 'policy',
          title: 'Apólice',
          action: 'goToCreateProposal',
          id:'mesa_criar_demanda_apolice'
        },
        endosso: {
          name: 'endorsement',
          title: 'Endosso',
          action: 'initCreateEndorsementFlow',
          id:'mesa_criar_demanda_endosso'
        }
      }
    };
  },

  computed: {
    filteredProposals() {
      return  this.filteredCotacoes || this.cotacoes
    },
  },
  methods: {
    debounceInput: _.debounce(function (e) {
      this.filteredCotacoes = this.getFiltro(this.cotacoes)
  }, 200),

    async advancedSearch(data){
      const filtros = {}
      data = data.replace(/[^a-zA-Z0-9\s]+/g, "");

      if (/[^0-9]/.test(data)) {
        filtros["nome_tomador"] = data
        this.filtroStatus = 'nome tomador'
      }
      else if(isCPF(data) || isCNPJ(data)) {
        filtros["tomador_documento"] = data
        this.filtroStatus = 'CPF/CNPJ do tomador'
      }
      else if(data.length == 13){
        filtros["id_apolice"] = data
        this.filtroStatus = 'número da apólice'
      }
      else{
        filtros["id_proposta"] = data
        this.filtroStatus = 'número da proposta'
      }
      if (data) {
        this.id_apolice = data;
        this.cotacoesApolice = false;
      }
      let proposals;
      try {
        this.showLoadingIndicator();
        proposals = await this.$store.dispatch("GET_PROPOSALS", 
          {filtros});
      } catch (e) {
        console.warn(e);
      } finally {
        this.hideLoadingIndicator();
        this.visible = true
      }
      this.teste = proposals;
      this.filteredCotacoes = proposals;
      
    },
    filterPolicies(term) {  
      let filtered = this.policiesPlusNomination;

      if (!_.isEmpty(term)) {
        const policyNumberRe = new RegExp(`^${term}`);
        filtered = this.policiesPlusNomination.filter(
          ({ id_apolice }) => policyNumberRe.test(id_apolice.toString())
        );
      }

      this.filteredPolicies = filtered;
    },
    goToCreateProposal() {
      this.$router.push({ path: "/proposta/novo" });
    },
    initCreateEndorsementFlow() {
      this.selectEndorsementKindModal = true;
    },
    handleDropdownClickAction(kind) {
      let whichAction = this.yellowDropdownOptions[kind];
      let action = whichAction.action;
      this[action]();
    },
    resetEndorsementFlow() {
      this.selectedKindEndorsement = false;
    },

    async selectKindEndorsement (data) {
      this.selectedKindEndorsement = data.kind;
      this.selectEndorsementKindModal = false;
      try {
        this.showLoadingIndicator();
        this.policiesPlusNomination = await this.$store.dispatch("GET_POLICIES");
        this.filteredPolicies = this.policiesPlusNomination
        this.searchPolicyModal = true;
      } catch (e) {
        console.error(e);
      } finally {
        this.hideLoadingIndicator();
      }
    },
    async handleSelectedPolicy (data) {
      let policyDetails;
      
      try {
        this.showLoadingIndicator();
        policyDetails = await this.$store.dispatch("GET_POLICY", { apoliceId: data.id_apolice });

        this.selectedPolicy = policyDetails
        

        if (canEndorse(policyDetails)) {
          this.goToPolicyForEndorse(data);
        } else {
          this.showEndorsementPermissionProblems(policyDetails);
        }
      } catch (error) {
          this.setErrorModal(error.response.data)
      } finally {
        this.hideLoadingIndicator();
      }
    },
    showEndorsementPermissionProblems(data) {
      this.selectedPolicyForEndorsement = data;
      this.endorsementPermissionProblemsModal = true;
    },

    goToPolicyForEndorse({ id_apolice }) {
      if (this.selectedKindEndorsement == KIND_ENDORSEMENTS.ALTERACAO) {
        this.$router.push({ path: `/apolice/${id_apolice}/endossar/alterar-vigencia-is` });
      }
      if (this.selectedKindEndorsement == KIND_ENDORSEMENTS.CANCELAMENTO) {
        this.showEndossoCancelamentoDialog = true
      }
    },

    goToFullProposal({ id_apolice, id, id_produto, status }) {
      if (status == "Emitida") {
        this.$router.push({ path: `/apolice/${id_apolice}` });
      } else if (status != "CORRETOR_ANALISE_EMISSAO") {
        this.$router.push({ path: `/proposta/${id}/${id_produto}` });
      } else {
        this.$router.push({ path: `/proposta/editar/${id}/${id_produto}` });
      }
    },

    darkenEverythingExcept(selector) {
      let t = this;
      let el = document.querySelector(selector);
      el.className += " shadow-everything-except";
      let shadowText = el.querySelector(".shadow-text");
      shadowText.style.display = "block";

      setTimeout(() => {
        el.classList.remove("shadow-everything-except");
        shadowText.style.display = "none";
      }, 5000);
    },

    async getProposals(idApolice) {
      if (idApolice) {
        this.id_apolice = idApolice;
        this.cotacoesApolice = false;
      }

      let proposals;
      try {
        this.showLoadingIndicator();
        proposals = await this.$store.dispatch("GET_PROPOSALS", {
          idApolice
        });
      } catch (e) {
        console.warn(e);
      } finally {
        this.hideLoadingIndicator();
      }

      if (idApolice) this.cotacoesApolice = proposals;
      else this.cotacoes = proposals;
    },

    getFiltro(cotacoes) {
      const generalSearch = this.searchFilter.generalSearch.toLowerCase();
      const hasIndexOf = (x, y) => x.indexOf(y) !== -1;

      const checkGeneralTermText = item => {
        const term = generalSearch;
        return hasIndexOf(item.id.toString().toLowerCase(), term) ||
          (
            item.id_apolice &&
            hasIndexOf(item.id_apolice.toString().toLowerCase(), term)
          ) ||
          hasIndexOf(item.tomador.nome.toLowerCase(), term) ||
          hasIndexOf(item.segurado.nome.toLowerCase(), term) ||
          hasIndexOf(item.produto.nome.toLowerCase(), term);
      };

      const checkGeneralTermNumber = item => {
        const term = generalSearch.replace(/[^\d]+/g, "");
        const isDocumentNumber = isCNPJ(term) ||  isCPF(term);
        return isDocumentNumber && (
          hasIndexOf(item.tomador.documento.toString().toLowerCase(), term) ||
          hasIndexOf(item.segurado.documento.toString().toLowerCase(), term)
        );
      };

      return cotacoes.filter(
        item => checkGeneralTermText(item) || checkGeneralTermNumber(item)
      );
    }
  },

  mounted() {
    this.$watch(
      "$refs.buscaAvancada.filtros",
      (new_value, old_value) => (console.log(new_value))
    );
    let t = this;
    this.hideLoadingIndicator();
    this.getProposals();
  },
};
</script>

<style lang="scss" scoped>
#jns {
  .layout-search {
    padding: 3vh 2vh;
  }

  .busca_status {
    margin-top: -15px;
    margin-bottom: 14px;
    font-size: 1.8rem;
    font-weight     : bold;
    color: #061d45;
    
    
  }

  .busca_avancada {
    margin-top: -10px;
    margin-bottom: -15px;
    margin-left: -2.5px;
    width           : 15%;
    height          : 45px;
    border-radius   : 25px;
    background-color: #061d45;
    font-family     : Helvetica;
    font-size       : 1.0rem;
    font-weight     : bold;
    text-align      : center;
    color           : white;
    box-shadow      : 0 0 7px 0 rgba(0, 0, 0, 0.13);
    border          : 1px solid #061d45;
  }


  .texto_busca_avancada {
    margin-left: 20px;
  }


  .kanban-container.container {
    margin-top: -40px;
    position: relative;
    padding: 16px !important;
    overflow-x: auto;

    h1 {
      font-size: 18px;
      margin-bottom: 20px;
    }
    & > .layout {
      height: 100%;
    }
  }

  .kanban-column {
    height: auto;
    width: 100%;
    max-height: 66vh;
    overflow: auto !important;
    border: 0;
  }

  .kanban-header {
    flex-basis: 0;
    border: 0.1vh solid #9797979e !important;
    margin-right: 10px;
    border-radius: 4px;
    width: 25vw;

    &:last-of-type {
      border-right: 0.1vh solid #cbcbcb;
    }
  }

  .kanban-header-title {
    font-size: 2vh;
    line-height: 8vh;
    height: 8vh;
    margin: 0 1vh !important;
    font-weight: bold;
    white-space: nowrap;
    

    i {
      margin-top: -2px;
      font-size: 20px;
      cursor: pointer;
    }

    span {
      float: right;
      margin-right: 15px;
    }

    &.text-blue {
      color: #282498;
      i {
        color: #282498;
      }
    }

    &.text-yellow {
      color: #cec203;
      i {
        color: #cec203;
      }
    }

    &.text-green {
      color: #5bad01;
      i {
        color: #5bad01;
      }
    }

    &.text-gray {
      color: #636363;
    }
  }

  .home-criar-menu {
    margin-top: -2px;
    position: absolute;
    width: 100%;
    z-index: 99;
    left: 0;
    padding-left: 0;

    li {
      cursor: pointer;
      border-top: 0.1vh solid rgba(255, 255, 255, 0.13);
      text-decoration: none;
      list-style: none;
      background-color: #f1e41e;
      color: #061d45;
      text-align: center;
      padding: 13px 26px;
      transition: all 0.2s ease;
      font-weight: bold;
      &:hover {
        background-color: #061d45;
        a {
          color: white;
        }
      }
      a {
        text-decoration: none;
      }
    }
    li:last-of-type {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  .criar-menu-container {
    position: relative;
  }

  .shadow-everything-except {
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.7);
  }

  .cotacoes-counter {
    float: right;
    margin-right: 10px;
  }
}
.sm12 {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/MesaDeTrabalho/Listar.vue